import { render, staticRenderFns } from "./HistorySection.vue?vue&type=template&id=53cb556e&scoped=true"
import script from "./HistorySection.vue?vue&type=script&lang=js"
export * from "./HistorySection.vue?vue&type=script&lang=js"
import style0 from "./HistorySection.vue?vue&type=style&index=0&id=53cb556e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cb556e",
  null
  
)

export default component.exports